import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { capitalize } from '@iotv/core-services';
import { dayMaskAllTrueTemplate, dayMaskDays, dayMaskTemplate } from '@iotv/iotv-v3-types';
import { Button, FormControl, FormGroup, FormLabel, Skeleton, Stack } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../../../../ContextProviders/AppContextProvider';
import { Timezone } from '../../common/Timezone';
export const DayMask = ({ dayMask, setDaymask }) => {
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const [localDayMask, setLocalDayMask] = useState(null);
    const [pendingToggle, setPendingToggle] = useState(dayMaskTemplate);
    const setPending = (day, pending) => {
        setPendingToggle((dm) => {
            const clone = structuredClone(dm ?? dayMaskAllTrueTemplate);
            clone[day] = pending;
            return clone;
        });
    };
    const setLocal = (day, enabled) => {
        setLocalDayMask((dm) => {
            const clone = structuredClone(dm ?? dayMaskAllTrueTemplate);
            clone[day] = enabled;
            setDaymask(clone);
            return clone;
        });
    };
    useEffect(() => {
        if (dayMask) {
            // iterate over each day
            Object.entries(dayMask).forEach((dayPair) => {
                const [day, enabled] = dayPair;
                // if the day matches
                if (enabled === localDayMask?.[day]) {
                    // clear pending
                    setPending(day, false);
                }
                else {
                    // if the day is different, and the update isn't pending
                    if (!pendingToggle[day]) {
                        // do the update
                        setLocal(day, enabled);
                        setLocalDayMask((dm) => {
                            const clone = structuredClone(dm ?? dayMaskAllTrueTemplate);
                            clone[day] = enabled;
                            setDaymask(clone);
                            return clone;
                        });
                    }
                }
            });
        }
    }, [dayMask]);
    const toggleDay = (day) => {
        setPending(day, true);
        setLocal(day, !localDayMask?.[day]);
    };
    return (_jsxs(Stack, { alignItems: isSmallView ? 'center' : 'flex-end', gap: 1, children: [_jsx(Timezone, {}), _jsxs(Stack, { direction: isSmallView ? 'column' : 'row', alignItems: 'flex-end', gap: 1, children: [_jsx(FormLabel, { sx: { lineHeight: '2.1em' }, children: "Scheduled days:" }), _jsx(FormControl, { children: _jsx(FormGroup, { row: true, sx: { gap: 1 }, children: dayMaskDays.map((k) => {
                                const label = capitalize(k).charAt(0);
                                return localDayMask ? (_jsx(Button, { variant: "contained", color: localDayMask[k] ? 'primary' : 'inherit', disabled: pendingToggle[k], onClick: () => toggleDay(k), sx: {
                                        minWidth: '2em',
                                        padding: 0,
                                        fontSize: 'larger',
                                    }, children: label }, k)) : (_jsx(Skeleton, { variant: "rounded", height: '2.1em', width: '2.4em' }));
                            }) }) })] })] }));
};
